import styled from "styled-components";
import Icon from "./Icon";

export const StyledIcon = styled(Icon)``;

export default StyledIcon;
